// Single source of truth for ProjectType (mirrors the backend enum in
// Models/Project.cs). `index` MUST match the backend enum's numeric value.
//
// Two representations are in play and both matter:
//   index — what Project.type is on the wire (ProjectModal posts a number)
//   key   — what automation conditions store ({"field":"type","value":"RepairLog"})
export const PROJECT_TYPES = [
  { index: 0, key: 'RepairLog',                     label: 'Repair Log' },
  { index: 1, key: 'ResidentialInsurance',          label: 'Residential Insurance' },
  { index: 2, key: 'ResidentialRetail',             label: 'Residential Retail' },
  { index: 3, key: 'Commercial',                    label: 'Commercial' },
  { index: 4, key: 'PropertyManagement',            label: 'Property Management' },
  // JN parity: PM work on a residential property. Appended to the backend enum
  // later than the rest, so older hardcoded lists in the UI may omit it.
  { index: 5, key: 'PropertyManagementResidential', label: 'PM – Residential' },
];

export const PROJECT_TYPE_KEYS = PROJECT_TYPES.map(t => t.key);

export const projectTypeLabel = (keyOrIndex) =>
  PROJECT_TYPES.find(t => t.key === keyOrIndex || t.index === keyOrIndex)?.label ?? String(keyOrIndex ?? '');
